<template>
  <div v-show="visible" class="loading-wrap">
    <div class="loading-box">
      <i class="icon icon-outer-layer" />
      <i class="icon icon-inner-layer" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
};
</script>
<style lang="scss" scoped>
.loading-wrap {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #101314;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  perspective: 1000px;
}
.loading-box {
  position: relative;

  .icon-outer-layer,
  .icon-inner-layer {
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(-50%, -50%);
  }

  .icon-outer-layer {
    opacity: 0;
    animation: outerLayer 2s ease-in-out infinite;
  }

  .icon-inner-layer {
    opacity: 0;
    animation: innerLayer 2s ease-in-out infinite;
  }

  @keyframes innerLayer {
    0% {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0);
    }
    50% {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes outerLayer {
    0% {
      opacity: 0;
      transform: translate(-50%, -50%) rotateX(0deg);
    }
    20% {
      opacity: 1;
      transform: translate(-50%, -50%) rotateX(180deg);
    }
    40% {
      opacity: 1;
      transform: translate(-50%, -50%) rotateX(180deg);
    }
    100% {
      opacity: 1;
      transform: translate(-50%, -50%) rotateX(180deg) rotate(720deg);
    }
  }

  @keyframes myLoading {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
